import { useLayoutEffect, useRef, type ReactNode } from 'react';
import { log } from '@hungryroot/o11y';
import styles from './QuizFieldset.module.css';

interface Props {
  children: ReactNode;
  legend?: ReactNode;
  scrollToTop?: boolean;
}

export function QuizFieldset({ children, legend, scrollToTop = false }: Props) {
  const ref = useRef<HTMLFieldSetElement>(null);

  useLayoutEffect(() => {
    const { current } = ref;
    if (current === null) {
      return;
    }

    if (scrollToTop === true) {
      // on iOS window.scrollTo doesn't seem to work as expected https://forums.developer.apple.com/forums/thread/703294
      // using window.scroll(0, 0) will unexpectedly not work/navigate the user to the bottom of
      // the page, see details here https://hungryroot.atlassian.net/browse/WEB-3226
      window.scroll(0, 1);
      if (window.scrollY > 1) {
        log('funnel', {
          scope: 'quiz',
          event: 'scroll-mismatch',
          expectedScrollY: 1,
          actualScrollY: window.scrollY,
        });
      }
      return;
    }

    current.scrollIntoView({ behavior: 'smooth' });
  }, [scrollToTop]);

  return (
    <fieldset className={styles.fieldset} ref={ref}>
      {legend && <legend className={styles.legend}>{legend}</legend>}
      {children}
    </fieldset>
  );
}
